module.exports = __webpack_public_path__ + "static/media/19_Club_house_Secor_A_new.3475cf7e.jpg";